import Request from '@/requests/Request'
const resource = "/monitoramentos";

export default {
  findById(monitoramentoId) {
    return Request.get(`${resource}/${monitoramentoId}`)
  },
  findByParentId(indicadorId) {
    return Request.get(`/indicadores/${indicadorId}${resource}`)
  },
  post(indicadorId, progresso, responsavelId, data, lancamentoId) {
    const form = new FormData();
    form.append('progresso', progresso);
    form.append('responsavelId', responsavelId);
    form.append('data', data);
    form.append("lancamentoId", lancamentoId)
    return Request.post(`${resource}/indicador/${indicadorId}`, form)
  },
  put(monitoramentoId, progresso) {
    return Request.post(`${resource}/` + monitoramentoId, progresso)
  },
  delete(monitoramentoId) {
    return Request.delete(`${resource}/${monitoramentoId}`)
  },
}
